import MobileSummary from "../MobileSummary";
import useSummaryPage from "../Summary/useSummaryPage";

const MobileSummaryWrap = () => {
  useSummaryPage();
  return <MobileSummary fromShare={false} />;
};

export default MobileSummaryWrap;
